import { ReactNode, Ref } from "react"
import { TextInputInstance, TextInputProps as RNTextInputProps } from "react-native"
import { Text } from "./Typography"
import styled from "@emotion/native"

type TextInputProps = RNTextInputProps & {
  labelText?: string
  rightIcon?: ReactNode
  ref?: Ref<TextInputInstance>
}

export function TextInput({ labelText, rightIcon, ref, ...inputProps }: TextInputProps) {
  const { style, ...restInputProps } = inputProps

  return (
    <InputContainer>
      {!!labelText && (
        <Label>
          <Text type="label" color="tertiary2">
            {labelText}
          </Text>
        </Label>
      )}
      <InputField>
        <StyledTextInput
          ref={ref}
          maxFontSizeMultiplier={1.5}
          {...restInputProps}
          style={rightIcon ? [style, rightIconPadding] : style}
        />
        {!!rightIcon && <RightIconWrapper pointerEvents="none">{rightIcon}</RightIconWrapper>}
      </InputField>
    </InputContainer>
  )
}

const Label = styled.View`
  margin-bottom: 8px;
`

const rightIconPadding = { paddingRight: 58 }

const InputContainer = styled.View`
  height: 80px;
`

const InputField = styled.View`
  justify-content: center;
`

const RightIconWrapper = styled.View`
  position: absolute;
  right: 14px;
  height: 54px;
  justify-content: center;
`

const StyledTextInput = styled.TextInput`
  background-color: ${({ theme }) => theme.textInput.backgroundColor};
  width: 100%;
  height: 54px;
  font-size: 18px;
  line-height: 23.4px;
  padding-left: 25px;
  border-radius: 14px;
  color: ${({ theme }) => theme.textInput.textColor};
`
